module.exports = __webpack_public_path__ + "static/media/tlyfe-rent-logo.56cd20b4.png";